export default __webpack_public_path__ + "bd00a49f35b6f1e54a807805e59a9def.png";